import { parseZonedDateTime } from '@rematter/common/dateTime';

import { assistantChatWithAgentFragment } from './fragmentsAssistantChat';

import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type SharedChatRecord = NonNullable<
  QueryAtomResult<typeof assistantChatByShareTokenQueryAtom>['chat']
>;

export const assistantChatByShareTokenQueryAtom = createQueryAtomFactory(
  'assistant.chatByShareToken',
  (params: { token: string }) => ({
    assistantChatByShareToken: {
      __args: {
        token: params.token,
      },
      ...assistantChatWithAgentFragment,
      isShared: true,
    },
  }),
  {
    select: ({ assistantChatByShareToken }) => ({
      chat: assistantChatByShareToken
        ? {
            ...assistantChatByShareToken,
            createdAt: parseZonedDateTime(
              assistantChatByShareToken.timestamps.createdAt,
            ),
            updatedAt: parseZonedDateTime(
              assistantChatByShareToken.timestamps.updatedAt,
            ),
          }
        : null,
    }),
  },
);
